export enum ResponseChannel {
    Email = 'Email',
    SMS = 'SMS',
    Respond = 'Respond',
    InternalNote = 'InternalNote',
    DirectMessage = 'DirectMessage',
}
